export default {
  state: () => ({
    playing: null,
  }),
};
